import React, { useState, useEffect } from 'react';
import { MagnifyingGlassIcon, FunnelIcon, XMarkIcon } from '@heroicons/react/24/outline';

const ShopFilters = ({ filters, onFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilterChange(localFilters);
  };

  const handleReset = () => {
    const resetFilters = { search: '', status: '' };
    setLocalFilters(resetFilters);
    onFilterChange(resetFilters);
  };

  return (
    <div className="p-4 border-b border-gray-200 bg-gray-50 rounded-lg shadow-sm">
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col md:flex-row gap-3">
          {/* Search Input */}
          <div className="relative flex-1">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              name="search"
              value={localFilters.search}
              onChange={handleInputChange}
              placeholder="Rechercher par nom de boutique..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none transition duration-300"
            />
          </div>

          {/* Filters Toggle Button */}
          <button
            type="button"
            className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md hover:bg-gray-100 transition duration-300"
            onClick={() => setIsOpen(!isOpen)}
          >
            <FunnelIcon className="h-4 w-4 text-gray-600" />
            <span className="text-sm font-medium text-gray-700">Filtres</span>
          </button>

          {/* Apply Filters Button */}
          <button
            type="submit"
            className="px-4 py-2 bg-primary text-white rounded-md cursor-pointer transition duration-300"
          >
            Appliquer
          </button>
        </div>

        {/* Advanced Filters Section */}
        {isOpen && (
          <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Status Filter */}
            <div>
              <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1">
                Statut
              </label>
              <select
                id="status"
                name="status"
                value={localFilters.status}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none transition duration-300"
              >
                <option value="">Tous</option>
                <option value="pending">En attente</option>
                <option value="approved">Ouverte (Approuvée)</option>
                <option value="rejected">Rejetée</option>
                <option value="closed">Fermée</option>
              </select>
            </div>

            {/* Reset Filters Button */}
            <div className="flex items-end">
              <button
                type="button"
                className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md hover:bg-gray-100 transition duration-300"
                onClick={handleReset}
              >
                <XMarkIcon className="h-4 w-4 text-gray-600" />
                <span className="text-sm font-medium text-gray-700">Réinitialiser</span>
              </button>
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default ShopFilters;
